var _style, _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1921 720",
    style: {
      enableBackground: "new 0 0 1921 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_1_);}\n\t.st2{opacity:0.1;}\n\t.st3{fill:#929497;fill-opacity:0.3;}\n\t.st4{fill:#929497;fill-opacity:0.4;}\n\t.st5{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st6{fill:#929497;fill-opacity:0.9;}\n\t.st7{opacity:0.2;fill:#F1F1F2;enable-background:new    ;}\n\t.st8{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st9{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st10{opacity:0.3;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st11{opacity:0.8;fill:#212123;enable-background:new    ;}\n\t.st12{opacity:0.1;fill:#58595B;enable-background:new    ;}\n\t.st13{fill:url(#SVGID_3_);}\n\t.st14{fill:#060506;}\n\t.st15{fill:#858585;}\n\t.st16{opacity:0.8;fill:#565656;enable-background:new    ;}\n\t.st17{opacity:0.1;fill:#FEFEFE;enable-background:new    ;}\n\t.st18{opacity:0.8;fill:#1A1A1A;enable-background:new    ;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -337.9,
    y: -591.8,
    width: 2607,
    height: 1961.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -337.9,
    y: -591.8,
    width: 2607,
    height: 1961.4,
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5024.5376,
    y1: -1466.3138,
    x2: 3881.6079,
    y2: -53.9259,
    gradientTransform: "matrix(-1 0 0 1 5538 1274)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77648F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1920,
    height: 719
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3,1369.6l2199.7-724L1861.8-591.8l-2199.7,724L69.3,1369.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1324.3-97.9l-201.8,66.4l268.2,135.4L1324.3-97.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.3,176.2L174.5-36.4L-143.3,68.1L68.3,176.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M423.6,336.2l243.3-80.1L343.5,92.9L423.6,336.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1710.1,814.4l243.3-80.1L1630,571.1L1710.1,814.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2003.4,490.4c-140.7,46.3-292.2-30.4-338.5-171.2c-46.3-140.7,29.9-292.7,170.6-339L2003.4,490.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-118.2,144.5c119.9-3.3,232.6,71.7,272.1,191.6C193.4,456,147,583.4,48.8,651.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M571.6,287.5l200.2,608.2l490.4-161.4L1062,126.1L571.6,287.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.2334,
    y1: 422.5099,
    x2: 639.2334,
    y2: 405.0099,
    gradientTransform: "matrix(1 0 0 -1 0 720)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E68AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7E68AC",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-184.8,81.8l54.8,166.3l297.7-98L366.5,771l174.4-57.4L342.1,92.7L603.6,6.7l-54.8-166.3L-184.8,81.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M881.6,918.6c-78.5-238.4-335.4-368-573.6-289.5L450,1060.7L881.6,918.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1364.2,262.3l155.2-307.4L1212-200.3l-155.1,307.4L1364.2,262.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 836.7054,
    y1: 429.1564,
    x2: 2038.3333,
    y2: -55.2737,
    gradientTransform: "matrix(1 0 0 -1 0 720)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B6B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7439,
    style: {
      stopColor: "#3C3C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404041"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1920.4,712.5l-574.6-271.2l78.8,239.6l-24.6,8.1l-137.9,45.4l-164.7-500.3l-41.8-126.8l864.6,425.7V712.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1519.7-45.5l-216.3-104.8l-93-282.5l164.1-54L1519.7-45.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M950.5,417.8c-104.4,34.4-161.2,146.9-126.8,251.3c34.4,104.4,146.9,161.2,251.3,126.8 c104.4-34.4,161.2-146.9,126.8-251.3C1167.5,440.2,1054.9,383.4,950.5,417.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1110.8-252.7c-68.2,22.5-105.3,96-82.9,164.2c22.5,68.2,96,105.3,164.2,82.9c68.2-22.5,105.3-96,82.9-164.2 C1252.6-238,1179.1-275.1,1110.8-252.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1274.9,220.3L493.8-175L254.1-96.1L1351.5,453l-64.5-196.1L1274.9,220.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M550.6-160.2l104.9,318.7l213.8-423.6L550.6-160.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.479659b136f2b16ad1bee2430e8b3c51.svg";
export { ForwardRef as ReactComponent };